import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { PhysicianFilter } from 'src/app/model/physician-Filter';
import { CacheFilterService } from 'src/app/services/cache/cache-filter.service';
import { PracticeRegionFilter } from '../../../model/practice-region-filter';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { PatientAssignationService } from '../../../services/patient-assignation.service';
import { PhysicianService } from '../../../services/physician.service';
import { PracticeService } from '../../../services/practice.service';

export class PatientCrmAssignmentDialogResponse {
  Physician: PhysicianFilter;
  PracticeRegion: PracticeRegionFilter;
}

export class PatientCrmAssignmentDialogRequest {
  PhysicianIds: number[] = [];
  PatientId: number;
}

@Component({
  selector: 'app-patient-crm-assignment-dialog',
  templateUrl: './patient-crm-assignment-dialog.component.html',
  styleUrls: ['./patient-crm-assignment-dialog.component.css']
})
export class PatientCrmAssignmentDialogComponent implements OnInit {

  filterCompletePhysicianFilter: FilterCompleteService<PhysicianFilter>;
  filterCompletePracticeRegionFilter: FilterCompleteService<PracticeRegionFilter>;
  form: FormGroup;
  practices: PracticeRegionFilter[] = [];

  constructor( private cacheFilterService: CacheFilterService,
               private notificationToastService: NotificationToastService,
               private patientAssignationService: PatientAssignationService,
               private practiceService: PracticeService,
               private formBuilder: FormBuilder,
               public dialogRef: MatDialogRef<PatientCrmAssignmentDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: PatientCrmAssignmentDialogRequest) {

    this.form = this.formBuilder.group({
      physician: ['', Validators.required],
      practiceRegion: [null, Validators.required]
    });

    this.filterCompletePhysicianFilter =
      new FilterCompleteService<PhysicianFilter>([], this.form.controls.physician);

    this.filterCompletePracticeRegionFilter =
      new FilterCompleteService<PracticeRegionFilter>([], this.form.controls.practiceRegion);

  }

  get f() { return this.form.controls; }

  get filterCompletePhysicianFilterOptions() { return this.filterCompletePhysicianFilter ?
    this.filterCompletePhysicianFilter.filteredOptions : [];
  }

  get filterCompletePracticeRegionFilterOptions() { return this.filterCompletePracticeRegionFilter ?
      this.filterCompletePracticeRegionFilter.filteredOptions : []; }

  async ngOnInit() {

    let physicians = await this.cacheFilterService.getPhysicianFilters();
    this.practices = await this.cacheFilterService.getPracticeRegionFilters();

    if ( this.data.PhysicianIds.length > 0) {
      physicians = physicians.filter
      (p => this.data.PhysicianIds.findIndex(e => e === p.Id) === -1);
    }

    this.filterCompletePhysicianFilter =
      new FilterCompleteService<PhysicianFilter>(physicians,
        this.form.controls.physician);

    this.form.controls.physician.valueChanges.subscribe(async (value) => {
      
      this.filterCompletePracticeRegionFilter =
      new FilterCompleteService<PracticeRegionFilter>([],
        this.form.controls.practiceRegion);

      this.form.controls.practiceRegion.setValue(null);

      if (typeof value !== 'string') {
        const prIds  = await this.practiceService.getPracticesRegionFilterPhysician(value.Id);
        
        const prFilters = this.practices
            .filter(p => prIds.findIndex(e => e === p.Id) !== -1);

        this.filterCompletePracticeRegionFilter =
        new FilterCompleteService<PracticeRegionFilter>(prFilters,
          this.form.controls.practiceRegion);

      }  
    });

   

  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  async save() {
    try {
      if (!this.form.invalid) {

        await this.patientAssignationService
          .assignTherapeuticCompanion(
              this.data.PatientId,
              this.form.controls.physician.value.Id,
              this.form.controls.practiceRegion.value.Id);

        this.dialogRef.close({
          Physician: this.form.controls.physician.value,
          PracticeRegion: this.form.controls.practiceRegion.value,
        });

      }
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(JSON.stringify(err.error), 'Asignación de profesional');
    }
  }

}
